var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUsHeadingArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 60,
    viewBox: "0 0 101 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7215 57.0799C81.7268 57.297 90.9295 56.8627 99.54 59.9421C100.053 60.1237 100.618 59.8592 100.803 59.346C100.985 58.8327 100.72 58.2682 100.207 58.0827C91.3953 54.9322 81.9834 55.327 72.7689 55.1059C72.2241 55.0901 71.7701 55.5244 71.7582 56.0692C71.7424 56.614 72.1767 57.0641 72.7215 57.0799Z",
    fill: "url(#paint0_linear_912_349)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9129 44.007C74.7199 41.4243 77.7835 39.4894 81.4867 38.5304C82.0157 38.3938 82.3315 37.8549 82.1973 37.3275C82.0591 36.8 81.5183 36.483 80.9932 36.6196C76.9663 37.6619 73.6303 39.7472 70.5785 42.5538C70.1758 42.9225 70.1482 43.5475 70.5193 43.9486C70.8864 44.3493 71.5142 44.3758 71.9129 44.007Z",
    fill: "url(#paint1_linear_912_349)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.107 15.8077C65.394 11.3959 67.9286 7.94461 71.8134 5.45227C72.2713 5.15815 72.4056 4.54701 72.1095 4.08865C71.8173 3.6303 71.2054 3.49685 70.7474 3.79097C66.4481 6.55059 63.6371 10.3698 62.2119 15.2546C62.058 15.7773 62.362 16.3261 62.8831 16.4785C63.4082 16.6313 63.9569 16.3304 64.107 15.8077Z",
    fill: "url(#paint2_linear_912_349)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7496 9.82115C18.9837 10.7225 18.2967 11.6937 17.7124 12.7276C17.4519 13.188 16.9939 14.1663 16.9228 15.0052C16.8439 15.899 17.1478 16.6531 17.9295 17.0503C18.9678 17.5769 19.797 17.522 20.4365 17.2034C21.0524 16.8975 21.534 16.2962 21.838 15.49C22.4184 13.9491 22.3315 11.5942 22.0275 10.2503C22.8447 9.40702 23.7409 8.64229 24.7003 7.96245C31.8461 2.8992 42.3279 4.76619 50.3936 12.3368C53.2164 14.9874 54.5745 20.554 55.2811 26.5601C56.3826 35.9116 55.7549 46.3563 55.668 49.4163C55.6483 50.172 55.7193 50.6205 55.7588 50.7101C55.9444 51.1507 56.2721 51.2652 56.501 51.3086C56.8327 51.3678 57.0972 51.3046 57.3103 51.1941C57.5985 51.0425 57.8355 50.7756 57.946 50.3638C58.0052 50.1364 58.021 49.8198 58.0131 49.4823C58.0052 49.2482 57.9578 48.9923 58.0052 48.8245C58.3131 47.7499 58.6842 46.7005 59.0475 45.6437C60.2595 42.0909 61.8268 38.7616 63.5679 35.4363C69.099 24.87 74.4484 13.7055 83.5168 5.65527C83.9235 5.29403 83.963 4.66947 83.5998 4.26204C83.2405 3.85461 82.6167 3.81749 82.2061 4.17913C72.9561 12.3885 67.4605 23.7452 61.8189 34.5207C60.3384 37.3494 58.9803 40.1821 57.8512 43.145C57.9657 37.9037 57.9223 30.6486 56.9629 24.2292C56.1102 18.5201 54.4876 13.4746 51.7437 10.8978C42.9082 2.60429 31.3842 0.805217 23.5593 6.35209C22.7224 6.94586 21.9249 7.59886 21.1827 8.30712C17.0887 0.914586 8.32419 -2.04837 0.57831 1.48741C0.0808682 1.71363 -0.136265 2.29951 0.088768 2.79498C0.317749 3.29045 0.902025 3.50917 1.39947 3.28296C8.37944 0.0969601 16.2951 2.94026 19.7496 9.82115ZM20.322 12.2961C20.0022 12.7478 19.7061 13.216 19.4298 13.7C19.2837 13.9598 19.031 14.4592 18.9244 14.948C18.9007 15.0625 18.8968 15.2417 18.8968 15.3246C19.1692 15.4588 19.3824 15.5236 19.5561 15.4363C19.7732 15.3289 19.8838 15.0763 19.9904 14.794C20.2589 14.0857 20.3457 13.1469 20.322 12.2961Z",
    fill: "url(#paint3_linear_912_349)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_349",
    x1: 71.7578,
    y1: 55.1055,
    x2: 72.7746,
    y2: 63.4299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_349",
    x1: 70.2578,
    y1: 36.5879,
    x2: 75.3334,
    y2: 47.4801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_912_349",
    x1: 62.1719,
    y1: 3.63477,
    x2: 73.2609,
    y2: 15.5969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_912_349",
    x1: 0,
    y1: 0,
    x2: 32.9001,
    y2: 73.9869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsHeadingArrow);
export default __webpack_public_path__ + "static/media/aboutUsHeadingArrow.7f297635cc644ae2b79ace582439a4fb.svg";
export { ForwardRef as ReactComponent };